<template>
     <section class="clp__header">            
            <div class=" clp__header-content">
                <div class="container-xl">
                    <h1>{{ lang("Univer_aktualis")}}</h1>
                    <div class="clp__btn--mobile" @click="showCategoriesFilter">{{lang('kategoriak_szuro')}}</div>
                    <div class="clp__category-menu-wrap" v-if="NewsCategory">
                        <div class="clp__category-menu-close--mobile" @click="closeCategoriesFilter"></div>
                        <div class="clp__category-menu--mobile-title">{{ lang('kategoriak_mobil_cim')}}</div>
                        <ul class="news__category-menu clp__category-menu">
                            <li class="all-news-link" @click="GTMProdCatClick('Összes aktuális')">
                                <router-link :to="{ name: 'NewsAll_' + currentLangName()}">    
                                    <div class="img-wrap">
                                        <img 
                                            src="@/assets/images/icons/news/osszes_aktualis_kategoria_icon.svg" 
                                            :alt="lang('osszes_aktualis')" 
                                            :title="lang('osszes_aktualis')"  
                                            class="img-fluid"  />                                    
                                    </div>                                   
                                    <div>{{lang('osszes_aktualis')}}</div>
                                </router-link>
                            </li>                
                            <li v-for="category in NewsCategory" :key="category.id + '_' + currentLangName()" @click="GTMProdCatClick(category.name)">
                                <router-link :to="{ name: 'News_' + currentLangName(), params: {news_category_slug: category.slug}}">   
                                    <div class="img-wrap">
                                        <img v-if="category.image" 
                                            :src="src_url + '/' + category.image.path + '/' +category.image.file_name" 
                                            :alt="category.name" 
                                            :title="category.name"  
                                            class="img-fluid"  />   
                                        </div>
                                    <div>{{ category.name }}</div>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>  
</template>

<script>
import $ from "jquery"

export default {
    data(){
        return{
            src_url: process.env.VUE_APP_BIFROST_API_URL_NO_PROJECTNAME
        }
    },
    computed:{       
        NewsCategory(){            
            return this.$store.getters.getNewsCategory; 
        }              
    },
    methods:{
        showCategoriesFilter(){
            $('.clp__category-menu-wrap').addClass('show')
        },
        closeCategoriesFilter(){
            $('.clp__category-menu-wrap').removeClass('show')
        },
        GTMProdCatClick(category){          
            this.setDataLayer('actuals_category', category, '')                  
        } 
    },
    watch:{
        $route: function(){
            //close the menu when change the route
            $('.clp__category-menu-wrap').removeClass('show')                          
        } 
    }   
}
</script>